import { useForm } from '@mantine/form';
import { useState } from 'react';
import type { AfterVat } from '../types/VatReturn';

const defaultAfterVat: AfterVat = {};

export function useAfterVatForm(currentAfterVats?: AfterVat) {
	const [inputs, setInputs] = useState<AfterVat>(
		currentAfterVats ?? defaultAfterVat,
	);

	const form = useForm<AfterVat>({
		mode: 'uncontrolled',
		initialValues: currentAfterVats ?? defaultAfterVat,
		validate: {
			valueOfSalesExcVat: (v) => !v && 'Please insert value',
			valueOfPurchasesExcVat: (v) => !v && 'Please insert value',
			valueOfSalesExcVatToEc: (v) => !v && 'Please insert value',
			valueOfPurchasesExcVatToEc: (v) => !v && 'Please insert value',
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
